<template>
  <div class="changingSituation">
    <div>
      <h2>材料配件</h2>
      <AddMaterials
        @confirmMaterials="confirmMaterials"
        :accessories="accessories"
        :status="status"
      />
    </div>
    <div>
      <h2>协同人员</h2>
      <CollaborativePersonnel
        @confirm="confirm"
        :peoples="peoples"
        :status="status"
      />
    </div>
    <div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
        :inline="true"
      >
        <h2 class="commonH2">收入费用</h2>
        <el-form-item label="材料收入金额：" prop="materialTotalRevenue">
          <el-input
            type="number"
            v-model.number="ruleForm.materialTotalRevenue"
            :disabled="status !== 4"
          ></el-input>
        </el-form-item>
        <h2 class="commonH2">支出费用</h2>
        <el-form-item label="答理费率(%)：" prop="adminRate">
          <el-input
            type="number"
            @change="calculateAdminAmount"
            v-model.number="ruleForm.adminRate"
            :disabled="status !== 4"
          ></el-input>
        </el-form-item>
        <el-form-item label="管理费：" prop="adminAmount">
          <el-input
            type="number"
            v-model.number="ruleForm.adminAmount"
            :disabled="status !== 4"
          ></el-input>
        </el-form-item>
        <el-form-item label="外包工资：" prop="outsourcingSalary">
          <el-input
            type="number"
            @change="calculateTotalExpenditure"
            v-model.number="ruleForm.outsourcingSalary"
            :disabled="status !== 4"
          ></el-input>
        </el-form-item>
        <el-form-item label="人工费：" prop="laborCost">
          <el-input
            type="number"
            @change="calculateTotalExpenditure"
            v-model.number="ruleForm.laborCost"
            :disabled="status !== 4"
          ></el-input>
        </el-form-item>
        <el-form-item label="材料成本总金额：" prop="materialTotalCostAmount">
          <el-input
            type="number"
            v-model.number="ruleForm.materialTotalCostAmount"
            :disabled="status !== 4"
          ></el-input>
        </el-form-item>
        <el-form-item label="支出总金额：" prop="totalExpenditure">
          <el-input
            type="number"
            v-model.number="ruleForm.totalExpenditure"
            :disabled="status !== 4"
          ></el-input>
        </el-form-item>
        <h2>利润</h2>
        <el-form-item label="剩余利润：" prop="residualProfit">
          <el-input
            type="number"
            v-model.number="ruleForm.residualProfit"
            :disabled="status !== 4"
          ></el-input>
        </el-form-item>
        <h2></h2>
        <el-form-item v-if="status === 4">
          <el-button
            :loading="false"
            type="primary"
            @click="submitForm('ruleForm')"
            >保存</el-button
          >
          <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import AddMaterials from "./AddMaterials";
import CollaborativePersonnel from "./CollaborativePersonnel";
import { submitEdit } from "@/api/ElevatorManagement";

export default {
  components: {
    AddMaterials,
    CollaborativePersonnel,
  },
  props: ["accessories", "peoples", "orderOriginCost", "status", "repairOrderId"],
  data() {
    return {
      ruleForm: {
        adminAmount: 0,
        adminRate: 0,
        laborCost: 0,
        materialTotalCostAmount: 0,
        materialTotalRevenue: 0,
        outsourcingSalary: 0,
        residualProfit: 0,
        totalExpenditure: 0,
      },
      loading: false,
      rules: {
        adminAmount: [{ required: true, message: " ", trigger: "change" }],
        adminRate: [{ required: true, message: " ", trigger: "change" }],
        laborCost: [{ required: true, message: " ", trigger: "change" }],
        materialTotalCostAmount: [
          { required: true, message: " ", trigger: "change" },
        ],
        materialTotalRevenue: [
          { required: true, message: " ", trigger: "change" },
        ],
        outsourcingSalary: [
          { required: true, message: " ", trigger: "change" },
        ],
        residualProfit: [{ required: true, message: " ", trigger: "change" }],
        totalExpenditure: [{ required: true, message: " ", trigger: "change" }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          console.log(this.peoples)
          const params = {
            ...this.ruleForm,
            orderTeamworkParamList: this.peoplesFinall || this.peoples,
            materialUseParamList: this.accessoriesFinall || this.accessories,
            repairOrderId: this.repairOrderId
          };

          const res = await submitEdit(params);
          if (res.code === 200) {
            this.$message.success("保存成功");
            this.$emit('submitForm')
          }
          this.loading = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    confirmMaterials(list) {
      this.accessoriesFinall = [...list];
      this.calculateAllMaterialSalesAmount(list);
      this.calculateAllMaterialsCostAmount(list);
    },
    // 计算材料收入总金额 ：自动计算 材料收入总金额= 材料售价* 数量 之和
    calculateAllMaterialSalesAmount(list) {
      this.ruleForm.materialTotalRevenue = list.reduce(
        (total, item) => total + item.useAmount * item.salesAmount,
        0
      );
      this.calculateAdminAmount();
    },
    // 计算材料成本总金额 ：材料成本总金额=材料成本价 * 数量 之和，允许手动改
    calculateAllMaterialsCostAmount(list) {
      this.ruleForm.materialTotalCostAmount = list.reduce(
        (total, item) => total + item.useAmount * item.costAmount,
        0
      );
      this.calculateTotalExpenditure();
    },
    // 计算管理费用 :管理费 二 材料收入总金额 * 管理费费率
    calculateAdminAmount() {
      if (this.ruleForm.adminRate && this.ruleForm.materialTotalRevenue) {
        this.ruleForm.adminAmount =
          (this.ruleForm.adminRate * this.ruleForm.materialTotalRevenue) / 100;
      }
      this.calculateTotalExpenditure();
      // this.ruleForm.adminAmount =
    },
    // 计算支出总金额：支出总金额=管理费 ＋外包工资＋ 人工费＋ 材料总成本
    calculateTotalExpenditure() {
      const form = this.ruleForm;
      const {
        adminAmount,
        outsourcingSalary,
        laborCost,
        materialTotalCostAmount,
      } = this.ruleForm;
      this.ruleForm.totalExpenditure =
        (adminAmount || 0) +
        (outsourcingSalary || 0) +
        (laborCost || 0) +
        (materialTotalCostAmount || 0);
      this.calculateResidualProfit();
    },
    // 计算利润 ：支出总金额 =材料收入总金额 一 支出总金额
    calculateResidualProfit() {
      const {
        totalExpenditure,
        materialTotalRevenue,
        adminAmount,
        outsourcingSalary,
        laborCost,
        materialTotalCostAmount,
      } = this.ruleForm;
      this.ruleForm.residualProfit =
        (materialTotalRevenue || 0) -
        ((adminAmount || 0) +
          (outsourcingSalary || 0) +
          (laborCost || 0) +
          (materialTotalCostAmount || 0));
    },
    confirm(list) {
      this.peoplesFinall = [...list];
    },
  },
  watch: {
    accessories: {
      handler(newVal) {
        if (newVal && newVal.length) {
          const arr = JSON.parse(JSON.stringify(newVal));
          this.calculateAllMaterialSalesAmount(arr);
          this.calculateAllMaterialsCostAmount(arr);
        }
      },
      deep: true,
    },
    orderOriginCost: {
      handler(newVal) {
        if (newVal && newVal.id) {
          const obj = JSON.parse(JSON.stringify(newVal));
          this.ruleForm = { ...obj }
        }
      },
      deep: true,
    }
  },
};
</script>
<style lang="scss">
.changingSituation {
  > div {
    > h2 {
      font-size: 16px;
    }
    margin-bottom: 20px;
  }
  .commonH2 {
    font-size: 16px;
  }
  .el-input__inner {
    height: 30px;
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/AnnualInspection/components/ChangingSituation.vue